export default __webpack_public_path__ + "static/home-cover_1-1fafd32a621c150e6ba96058250da27c.jpg";